<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <base-input label="Site Selection" class="col-md-6">
                            <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedSiteId" @change="updateTerminalList" :disabled="site_type != 'ho'">
                                <a-select-option v-for="site in validSites" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                            </a-select>
                        </base-input>
                        <!-- <base-input label="From" class="col-md-6">
                            <br><a-date-picker @change="onDateFilter2" :format="dateFormat" input-classes="form-control" style="width: 100%"/>
                        </base-input>  -->
                         <base-input label="Date Range" class="col-md-6">
                            <br><a-range-picker @change="onDateFilter2" :format="dateFormat" :allowClear="false" input-classes="form-control" style="width: 100%"/>
                        </base-input>

                        <base-input label="Terminal" class="col-md-6">
                            <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedTerminalId">
                                <a-select-option v-for="terminal in validTerminals" :key="terminal.id" :value="terminal.id">{{terminal.name}} ({{terminal.code}})</a-select-option>
                            </a-select>
                        </base-input>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <!-- <download-excel
                                worksheet="BIR Sales Reports"
                                name="bir_sales_reports.xls"
                                type="xls"
                                :fetch="excelData"
                                :fields="json_fields">
                                <button class="btn btn-sm btn-success float-right ml-2"
                                        style="border-radius: 24px; border:0px; width: 20%;">
                                    Generate Report in Excel
                                </button>
                            </download-excel> -->

                            <!-- <button @click="generateBIRExcel">Generate Report in Excel</button> -->
                            <button @click="generateBIRExcel" class="btn btn-sm btn-success float-right ml-2"
                                    style="border-radius: 24px; border:0px; width: 20%;">
                                Generate Report in Excel
                            </button>


                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                                Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';
    import * as XLSX from "xlsx";

    const fs = require('fs')

    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                selectedSiteId: [],
                site_type: "ho",
                selectedTerminalId: [],
                dateFormat: 'YYYY-MM-DD',
                searchDateFrom: null,
                searchDateTo: null,
                validSites: null,
                validTerminals: null,
                dateFilter: null,
                jsonData: [],
                json_fields: {
                    // 'Terminal Number':  'terminaId',
                    'Business Date':  'businessDate' ,
                    'Invoice Number (From)':  'beginningSi' ,
                    'Invoice Number (To)':  'endingSi' ,
                    'Beginning Balance': 'beginningBalance' ,
                    'Ending Balance': 'endingBalance' ,
                    'Gross Sales': 'grossSales' ,
                    'Vatable Sales': 'grossVatableSales' ,
                    'VAT Amount': 'grossVatAmount' ,
                    'VAT Exempt Sales': 'grossVatExemptSales' ,
                    'Zero Rated Sales': 'grossZeroRatedSales' ,
                    'Deductions (Regular Discount)': 'regularDiscount' ,
                    'Deductions (Special Discount 5%)': 'specialDiscount' ,
                    'Deductions (Special Discount 20%)': 'specialExemptDiscount' ,
                    'Deductions (Return)': 'totalReturns' ,
                    'Deductions (Void)': 'totalVoids' ,
                    'Deductions (Manual)': 'totalReplaced' ,
                    'Total Deductions': 'totalDeductions' ,
                    'Adjustments on VAT (Regular)': 'adjustmentOnVatRegular' ,
                    'Adjustments on VAT (Special 5%)': 'adjustmentOnVatSpecial' ,
                    'Adjustments on VAT (Special 20%)': 'adjustmentOnVatSpecialExempt' ,
                    'Adjustments on VAT (Return)': 'adjustmentOnVatReturns' ,
                    'Adjustments on VAT (Void)': 'adjustmentOnVatVoids' ,
                    'Adjustments on VAT (Manual)': 'adjustmentOnVatManual' ,
                    'Total Adjustments': 'totalVatAdjustments' ,
                    'VAT Payables': 'vatPayables' ,
                    'Net Amount Received': 'netAmountReceived' ,
                    'Other Income (Excess GC)': 'excessGC' ,
                    'Other Income (Excess RS)': 'excessRS' ,
                    'Sales Including Excess': 'salesWithExcess' ,
                    'Reset Counter': 'siResetCount' ,
                    'Z-Counter': 'zReadingCounter'
                },
                 imagepath: '',
                 reportDescription: ''
            }
        },
        mounted: async function () {
            var userId = secureStorage.getItem("userId")
            var site_data = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?user_id=' + userId, null)
            this.validSites = site_data
            // var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/get_valid_terminals', null)
            // this.validTerminals = terminal_data

            let siteId = secureStorage.getItem("defaultSiteId")
            this.selectedSiteId = siteId
            this.updateTerminalList()

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)


            let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
            if (logoSettings.length > 0) {
                let logo_img = logoSettings[0]["value"]
                this.imagepath = this.publicUrl + 'account_logos/' + logo_img
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'publicUrl']),
        },
        methods: {
            moment,
            async updateTerminalList(){
                var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/get_valid_terminals?site_id=' + this.selectedSiteId, null)
                this.validTerminals = terminal_data
            },
            onDateFilter2(date, dateString) {
                this.searchDateFrom = dateString[0]
                this.searchDateTo = dateString[1]
            },

            formattingExportData(businessDate, detail) {
                const safe = (v) => (v == null ? 0 : v); // handles null or undefined

                const { grossSales = {}, netSales = 0, deductions = {}, adjustmentsOnVat = {}, otherIncome = {} } = detail;
                const vatPayables = safe(grossSales.vatAmount) - safe(adjustmentsOnVat.total);
                const netAmountReceived = safe(netSales);
                const salesWithExcess = netAmountReceived + safe(otherIncome.total);

                // const fmt = (n) => formatNumber(Number(n || 0).toFixed(4));
                const fmt = (n) => {
                    const num = Number(n || 0).toFixed(4);   // "44.6000"
                    const [intPart, decPart] = num.split(".");  
                    const formattedInt = Number(intPart).toLocaleString();  
                    return `${formattedInt}.${decPart}`;  
                };

                return {
                    businessDate: moment(businessDate).format("MM-DD-YYYY"),
                    beginningSi: String(
                            detail.beginningSi != null ? detail.beginningSi : 0
                        ).padStart(8, "0"),
                    endingSi: String(
                            detail.endingSi != null ? detail.endingSi : 0
                        ).padStart(8, "0"),
                    beginningBalance: fmt(detail.beginningBalance),
                    endingBalance: fmt(detail.endingBalance),
                    grossSales: {
                        total:     fmt(grossSales.total),
                        vatable:   fmt(grossSales.vatable),
                        vatAmount: fmt(grossSales.vatAmount),
                        vatExempt: fmt(grossSales.vatExempt),
                        zeroRated: fmt(grossSales.zeroRated),
                    },

                    // "void":  - void
                    // "total":   - total deductions
                    // "manual": 0.0,
                    // "refund":  - refund
                    // "regular":  - others
                    // "returns":  - returns
                    // "voidCount": 0,
                    // "SCDiscount5": -  SC 5%
                    // "manualCount": 0,
                    // "refundCount": 0,
                    // "PWDDiscount5":  - PWD 5%
                    // "SCDiscount20": - SC 20%
                    // "returnsCount": 0,
                    // "voidDiscount": 0.0,
                    // "PWDDiscount20": - PWD 20%
                    // "movSPDiscount": - MOV
                    // "naacSPDiscount": - NAAC
                    // "returnDiscount": - others
                    // "specialVatableDiscount": 11.0014,
                    // "specialVatExemptDiscount": 0.0,
                    // "specialTenPercentDiscount": - Solo Parent

                    deductions: {
                        regular:                      fmt(deductions.regular),
                        SCDiscount5:                  fmt(deductions.SCDiscount5),
                        SCDiscount20:                 fmt(deductions.SCDiscount20),
                        PWDDiscount20:                fmt(deductions.PWDDiscount20),
                        PWDDiscount5:                 fmt(deductions.PWDDiscount5),
                        naacSPDiscount:               fmt(deductions.naacSPDiscount),
                        movSPDiscount:                fmt(deductions.movSPDiscount),
                        specialTenPercentDiscount:    fmt(deductions.specialTenPercentDiscount),
                        specialVatableDiscount:       fmt(deductions.specialVatableDiscount),
                        specialVatExemptDiscount:     fmt(deductions.specialVatExemptDiscount),
                        returns:                      fmt(deductions.returns),
                        refund:                       fmt(deductions.refund),
                        void:                         fmt(deductions.void),
                        manual:                       fmt(deductions.manual),
                        total:                        fmt(deductions.total),
                    },

                    //   "adjustmentsOnVat": {
                    //     "void": 0,
                    //     "total": 2.49,
                    //     "manual": 0,
                    //     "refund": 0,
                    //     "regular": 1.61,
                    //     "returns": 0,
                    //     "SCDiscount": 0,
                    //     "PWDDiscount": 0,
                    //     "movSPDiscount": 0,
                    //     "naacSPDiscount": 0,
                    //     "specialVatableDiscount": 0.88,
                    //     "specialVatExemptDiscount": 0,
                    //     "specialTenPercentDiscount": 0
                    // },

                    adjustments: {
                        SCDiscount:                   fmt(adjustmentsOnVat.SCDiscount),
                        PWDDiscount:                  fmt(adjustmentsOnVat.PWDDiscount),
                        specialTenPercentDiscount:    fmt(adjustmentsOnVat.specialTenPercentDiscount),
                        regular:                      fmt(adjustmentsOnVat.regular),
                        returns:                      fmt(adjustmentsOnVat.returns),
                        refund:                       fmt(adjustmentsOnVat.refund),
                        void:                         fmt(adjustmentsOnVat.void),
                        manual:                       fmt(adjustmentsOnVat.manual),
                        total:                        fmt(adjustmentsOnVat.total),
                    },
                    manualIssuedSales: fmt(deductions.manual+ adjustmentsOnVat.manual),
                    vatPayables:       fmt(vatPayables),
                    netAmountReceived: fmt(netAmountReceived),
                    otherIncome: {
                        excessGC: fmt(otherIncome.excessGC),
                        excessRS: fmt(otherIncome.excessRS),
                        total:    fmt(otherIncome.total),
                    },
                    totalIncome: fmt(otherIncome.total + netAmountReceived),
                    salesWithExcess: fmt(salesWithExcess),
                    siResetCount:    detail.resetCounterSI || "00",
                    zReadingCounter: String(
                            detail.zReadingCounter != null ? detail.zReadingCounter : 0
                        ).padStart(5, "0")
                };
            },

            totalAllAmount(allTotal, formattedDetails) {
                // toNum: convert formatted strings like "1,234.56" or numbers to Number
                const toNum = (v) => parseFloat(String(v == null ? "0" : v).replace(/,/g, ""));
                
                console.log("formattedDetails")
                console.log(formattedDetails)

                const { grossSales = {}, deductions = {}, adjustmentsOnVat = {}, otherIncome = {} } = formattedDetails;
                let adjustments = adjustmentsOnVat
                const vatPayables = toNum(grossSales.vatAmount) - toNum(adjustments.total);
                const netAmountReceived = toNum(formattedDetails.netSales);
                const salesWithExcess = netAmountReceived + toNum(otherIncome.total);

                // Gross Sales
                allTotal.totalSales               = (allTotal.totalSales || 0) + toNum(grossSales.total);
                allTotal.totalVatablesSales       = (allTotal.totalVatablesSales || 0) + toNum(grossSales.vatable);
                allTotal.totalVatAmount           = (allTotal.totalVatAmount || 0) + toNum(grossSales.vatAmount);
                allTotal.totalVatExemptSales      = (allTotal.totalVatExemptSales || 0) + toNum(grossSales.vatExempt);
                allTotal.totalZeroRatedSales      = (allTotal.totalZeroRatedSales || 0) + toNum(grossSales.zeroRated);

                // Deductions
                allTotal.totalRegularDeductions   = (allTotal.totalRegularDeductions || 0) + toNum(deductions.regular);
                allTotal.totalSCDiscount5         = (allTotal.totalSCDiscount5 || 0) + toNum(deductions.SCDiscount5);
                allTotal.totalSCDiscount20        = (allTotal.totalSCDiscount20 || 0) + toNum(deductions.SCDiscount20);
                allTotal.totalPWDDiscount20       = (allTotal.totalPWDDiscount20 || 0) + toNum(deductions.PWDDiscount20);
                allTotal.totalPWDDiscount5        = (allTotal.totalPWDDiscount5 || 0) + toNum(deductions.PWDDiscount5);
                allTotal.totalNaacSPDiscount      = (allTotal.totalNaacSPDiscount || 0) + toNum(deductions.naacSPDiscount);
                allTotal.totalSpecialTenPercent   = (allTotal.totalSpecialTenPercent || 0) + toNum(deductions.specialTenPercentDiscount);
                allTotal.totalMovSPDiscount       = (allTotal.totalMovSPDiscount || 0) + toNum(deductions.movSPDiscount);
                allTotal.totalReturnDeductions    = (allTotal.totalReturnDeductions || 0) + toNum(deductions.returns);
                allTotal.totalRefundDeductions    = (allTotal.totalRefundDeductions || 0) + toNum(deductions.refund);
                allTotal.totalVoidDeductions      = (allTotal.totalVoidDeductions || 0) + toNum(deductions.void);
                allTotal.totalManualDeductions    = (allTotal.totalManualDeductions || 0) + toNum(deductions.manual);
                allTotal.totalDeductions2         = (allTotal.totalDeductions2 || 0) + toNum(deductions.total);

                // Adjustments
                allTotal.totalVatAdjustmentSC            = (allTotal.totalVatAdjustmentSC || 0) + toNum(adjustments.SCDiscount);
                allTotal.totalVatAdjustmentPWD           = (allTotal.totalVatAdjustmentPWD || 0) + toNum(adjustments.PWDDiscount);
                allTotal.totalVatAdjustmentSpecialTen    = (allTotal.totalVatAdjustmentSpecialTen || 0) + toNum(adjustments.specialTenPercentDiscount);
                allTotal.totalVatAdjustmentRegular       = (allTotal.totalVatAdjustmentRegular || 0) + toNum(adjustments.regular);
                allTotal.totalVatAdjustmentReturn        = (allTotal.totalVatAdjustmentReturn || 0) + toNum(adjustments.returns);
                allTotal.totalVatAdjustmentRefund        = (allTotal.totalVatAdjustmentRefund || 0) + toNum(adjustments.refund);
                allTotal.totalVatAdjustmentVoid          = (allTotal.totalVatAdjustmentVoid || 0) + toNum(adjustments.void);
                allTotal.totalVatAdjustmentManual        = (allTotal.totalVatAdjustmentManual || 0) + toNum(adjustments.manual);
                allTotal.totalAdjustment2                = (allTotal.totalAdjustment2 || 0) + toNum(adjustments.total);

                // VAT payable & net amount
                allTotal.totalVatPayables        = (allTotal.totalVatPayables || 0) + vatPayables;
                allTotal.totalNetAmountReceived  = (allTotal.totalNetAmountReceived || 0) + toNum(formattedDetails.netSales);

                // Other income
                allTotal.totalExcessGC           = (allTotal.totalExcessGC || 0) + toNum(otherIncome.excessGC);
                allTotal.totalExcessRS           = (allTotal.totalExcessRS || 0) + toNum(otherIncome.excessRS);
                allTotal.totalOtherIncome        = allTotal.totalExcessGC + allTotal.totalExcessRS
                allTotal.totalSalesIncludingExcess = (allTotal.totalSalesIncludingExcess || 0) + salesWithExcess;
                allTotal.totalIncome            = allTotal.totalNetAmountReceived + allTotal.totalOtherIncome
            },
            async excelData() {
              this.spinning= true;

              if(this.searchDateFrom == null || this.searchDateTo == null || this.selectedTerminalId == ''){
                    this.$notification['error']({
                        message: 'Export Error',
                        description: 'Please make sure to check your current filters.'
                    });
                    this.spinning= false;
                    return
                }

              this.jsonData = [];
              const url = `${this.endPoint}z_readings/bir_sales_report?from=${this.searchDateFrom}&to=${this.searchDateTo}&terminal_id=${this.selectedTerminalId}`
              const queryResult = await HTTPRequest.getRequest(url, null)

              if (queryResult.report_details[0].report_details.length == 0) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
              const terminalZReadings = queryResult.report_details || []

              terminalZReadings.map(terminalZReading => {
                const zReadings = terminalZReading.report_details;
                const allTotal = {}

                console.log(">>> ZReading")
                console.log(terminalZReading)

                zReadings.map(zReading => {
                  const zReadingDetails = JSON.parse(zReading.reading_details);

                  this.totalAllAmount(allTotal, zReadingDetails);

                  const formattedDetails = this.formattingExportData(zReading.business_date, zReadingDetails);
                  const { grossSales, deductions, adjustments, otherIncome } = formattedDetails;

                  this.jsonData.push({
                    businessDate: formattedDetails.businessDate,
                    beginningSi: formattedDetails.beginningSi,
                    endingSi: formattedDetails.endingSi,

                    // Balances
                    beginningBalance: formattedDetails.beginningBalance,
                    endingBalance: formattedDetails.endingBalance,

                    // Manual
                    salesIssuedManual: formattedDetails.manualIssuedSales,

                    // Gross Sales
                    grossSales: grossSales.total,
                    grossVatableSales: grossSales.vatable,
                    grossVatAmount: grossSales.vatAmount,
                    grossVatExemptSales: grossSales.vatExempt,
                    grossZeroRatedSales: grossSales.zeroRated,

                    // Deductions
                    SCDiscount5:               deductions.SCDiscount5,              
                    SCDiscount20:              deductions.SCDiscount20,             
                    PWDDiscount20:             deductions.PWDDiscount20,            
                    PWDDiscount5:              deductions.PWDDiscount5,             
                    naacSPDiscount:            deductions.naacSPDiscount,           
                    specialTenPercentDiscount: deductions.specialTenPercentDiscount,
                    movSPDiscount:             deductions.movSPDiscount,            
                    regularDiscount:           deductions.regular,
                    totalReturns:              deductions.returns,
                    totalRefund:               deductions.refund,
                    totalVoids:                deductions.void, 
                    totalDeductions:           deductions.total,

                    // AdjustmentsOnVat
                    SCDiscount:                 adjustments.SCDiscount,                              
                    PWDDiscount:                adjustments.PWDDiscount,                            
                    adjSpecialTenPercentDiscount:  adjustments.specialTenPercentDiscount,
                    adjustmentOnVatRegular: adjustments.regular,
                    adjustmentOnVatReturns: adjustments.returns,
                    adjustmentOnVatVoids: adjustments.void,
                    adjustmentOnVatManual: adjustments.manual,
                    totalVatAdjustments: adjustments.total,

                    // Vat Payables & Net Amount Received
                    vatPayables: formattedDetails.vatPayables,
                    netAmountReceived: formattedDetails.netAmountReceived,

                    // Other Income
                    excessGC: otherIncome.excessGC,
                    excessRS: otherIncome.excessRS,
                    otherIncomeTotal: otherIncome.total,
          
                    // Other data
                    totalIncome: formattedDetails.totalIncome,
                    siResetCount: formattedDetails.siResetCount,
                    zReadingCounter: formattedDetails.zReadingCounter,
                  })
                }) // zReadings map loop

                //for (const key in allTotal) { allTotal[key] = formatNumber((parseFloat(allTotal[key]) || 0.00).toFixed(4)); }
                
                // Convert formatted string → number
                const toNum = (v) =>
                    parseFloat(String(v == null || v === "" ? "0" : v).replace(/,/g, ""));

                // Convert number → formatted string (no commas in decimal part)
                const toStr = (v) => {
                    const num = Number(v || 0);
                    const fixed = num.toFixed(4);
                    const [i, d] = fixed.split(".");
                    return `${Number(i).toLocaleString()}.${d}`;
                };

                // Final totals cleanup (safe)
                for (const key in allTotal) {
                    const numericValue = toNum(allTotal[key]);
                    allTotal[key] = toStr(numericValue);
                }

                // Input total values
                this.jsonData.push({
                  businessDate: "TOTAL:",
                  beginningSi: '',
                  endingSi: '',

                  // Balances
                  beginningBalance: '',
                  endingBalance: '',
                  salesIssuedManual: '',

                  // Gross Sales
                  grossSales: allTotal.totalSales,
                  grossVatableSales: allTotal.totalVatablesSales,
                  grossVatAmount: allTotal.totalVatAmount,
                  grossVatExemptSales: allTotal.totalVatExemptSales,
                  grossZeroRatedSales: allTotal.totalZeroRatedSales,

                  // Deductions
                  SCDiscount5:               allTotal.totalSCDiscount5,              
                  SCDiscount20:              allTotal.totalSCDiscount5,            
                  PWDDiscount20:             allTotal.totalPWDDiscount20,            
                  PWDDiscount5:              allTotal.totalPWDDiscount5,             
                  naacSPDiscount:            allTotal.totalNaacSPDiscount,         
                  specialTenPercentDiscount: allTotal.totalSpecialTenPercent,
                  movSPDiscount:             allTotal.totalMovSPDiscount,           
                  regularDiscount:           allTotal.totalRegularDeductions,
                  totalReturns:              allTotal.totalReturnDeductions,
                  totalRefund:               allTotal.totalRefundDeductions,
                  totalVoids:                allTotal.totalVoidDeductions,
                  totalDeductions:           allTotal.totalDeductions2,

    
                  SCDiscount:                 allTotal.totalVatAdjustmentSC,                              
                  PWDDiscount:                allTotal.totalVatAdjustmentPWD,                        
                  specialTenPercentDiscount:  allTotal.totalVatAdjustmentSpecialTen,
                  adjustmentOnVatRegular: allTotal.totalVatAdjustmentRegular,
                  adjustmentOnVatReturns: allTotal.totalVatAdjustmentReturn,
                  adjustmentOnVatVoids: allTotal.totalVatAdjustmentVoid,
                  adjustmentOnVatManual: allTotal.totalVatAdjustmentManual,
                  totalVatAdjustments: allTotal.totalAdjustment2,

                  // Vat Payables & Net Amount Received
                  vatPayables: allTotal.totalVatPayables,
                  netAmountReceived: allTotal.totalNetAmountReceived,

                  // Other Income
                  excessGC: allTotal.totalExcessGC,
                  excessRS: allTotal.totalExcessRS,
                  otherIncomeTotal: allTotal.totalOtherIncome,

                  totalIncome: allTotal.totalIncome,
                
                  // Other data
                  // salesWithExcess: allTotal.totalSalesIncludingExcess,
                  siResetCount: '',
                  zReadingCounter: '',
                })
              }) // terminalZReadings map loop
              this.spinning= false;
              return {records: this.jsonData, base: terminalZReadings};
            },
            async generateBIRExcel() {
                const main_data = await this.excelData(); 

                let data = main_data["records"]
                let base = main_data["base"][0]
                console.log("Base")
                console.log(base)
        
                if (!data || data.length === 0) return;

                
                // --------------------------
                // 1. DEFINE HEADER
                // --------------------------
                const header = [
                // Row 0: Main groups (r = 0)
                [
                    "Business Date", "Beginning SI No.", "Ending SI No",                    // 0–2
                    "Grand Accum. Sales Ending", "Grand Accum. Beg. Balance",              // 3–4
                    "Sales Issued w/ Manual SI/OR (per RR 16-2018)",                       // 5
                    "Gross Sales for the Day", "Vatable Sales", "VAT Amount",              // 6–8
                    "Vat-Exempt Sales", "Zero Rated Sales",                                // 9–10
                    "Deductions", "", "", "", "", "", "", "", "", "", "",                  // 11–21
                    "Adjustments on VAT", "", "", "", "", "", "", "",                        // 22–29
                    "VAT Payables", "Net Sales",                                           // 30–31
                    "Other Income", "", "",                                                // 32–34
                    "Total Income", "Reset Counter", "Z-Counter"                           // 35–37
                ],

                // Row 1: Sub-groups (r = 1)
                [
                    "", "", "", "", "", "", "", "", "", "", "",                               // 0–10
                    "Discount", "", "", "", "", "", "",                                        // 11–17 → Deductions → Discount
                    "Return", "Refund", "Void", "Total Deductions",                           // 18–21 → Deductions → Others
                    "Discount", "", "", "", "Return", "Void", "Manual", "Total Adjustments",  // 22–29 → Adjustments on VAT
                    "", "",                                                                    // 30–31 → VAT Payables / Net Sales
                    "Excess GC", "Excess RS", "Total",                                         // 32–34 → Other Income
                    "", "", ""                                                                  // 35–37 → Total Income / Reset / Z-Counter
                ],

                // Row 2: Detail breakdown (r = 2)
                [
                    "", "", "", "", "", "", "", "", "", "", "",                                  // 0–10 → main fixed columns
                    "SC", "", "PWD", "", "NAAC", "Solo Parent", "MOV", "Others",                // 11–18 → Deductions
                    "", "", "",                                                               // 18–21 → Return/Refund/Void/Total placeholders
                    "Regular", "Special (5%)", "Special (20%)", "Others",                       // 22–25 → Adjustments → Discount
                    "", "", "",                                                              // 26–29 → Return/Void/Manual/Total placeholders
                    "", "", "",                                                                  // 30–32 → VAT Payables / Net Sales / Other Income
                    "", "", "",                                                                  // 33–35 → Other Income → Excess GC / RS / Total
                    "", "", ""                                                                   // 36–37 → Total Income / Reset / Z-Counter
                ],


                // Row 3: Final level (r = 3, for Discount 5%/20% SC & PWD)
                [
                    "", "", "", "", "", "", "", "", "", "", "",                                // 0–10 → main fixed columns
                    "5%", "20%", "5%", "20%", "", "", "", "",                                     // 11–18 → Deductions → SC/PWD 5%/20%
                    "", "", "",                                                               // 18–21 → Return/Refund/Void/Total placeholders
                    "", "", "", "",                                                           // 22–25 → Adjustments → Discount
                    "", "", "",                                                              // 26–29 → Return/Void/Manual/Total placeholders
                    "", "", "",                                                                  // 30–32 → VAT Payables / Net Sales / Other Income
                    "", "", "",                                                                  // 33–35 → Other Income → Excess GC / RS / Total
                    "", "", ""                                                                   // 36–37 → Total Income / Reset / Z-Counter
                ],

                ];

                // --------------------------
                // 2. DEFINE MERGES
                // --------------------------
                const merges = [
                // ───────────── Row-span main fixed columns ─────────────
                { s:{ r:0,c:0 }, e:{ r:3,c:0 } }, // Business Date
                { s:{ r:0,c:1 }, e:{ r:3,c:1 } }, // Beginning SI No.
                { s:{ r:0,c:2 }, e:{ r:3,c:2 } }, // Ending SI No.
                { s:{ r:0,c:3 }, e:{ r:3,c:3 } }, // Grand Accum. Sales Ending
                { s:{ r:0,c:4 }, e:{ r:3,c:4 } }, // Grand Accum. Beg. Balance
                { s:{ r:0,c:5 }, e:{ r:3,c:5 } }, // Sales Issued Manual
                { s:{ r:0,c:6 }, e:{ r:3,c:6 } }, // Gross Sales
                { s:{ r:0,c:7 }, e:{ r:3,c:7 } }, // Vatable Sales
                { s:{ r:0,c:8 }, e:{ r:3,c:8 } }, // VAT Amount
                { s:{ r:0,c:9 }, e:{ r:3,c:9 } }, // VAT-Exempt
                { s:{ r:0,c:10 }, e:{ r:3,c:10 } }, // Zero Rated Sales

                // ───────────── Row 0 group headers ─────────────
                { s:{ r:0,c:11 }, e:{ r:0,c:21 } }, // Deductions
                { s:{ r:0,c:22 }, e:{ r:0,c:29 } }, // Adjustments on VAT
                { s:{ r:0,c:30 }, e:{ r:3,c:30 } }, // VAT Payables
                { s:{ r:0,c:31 }, e:{ r:3,c:31 } }, // Net Sales
                { s:{ r:0,c:32 }, e:{ r:0,c:34 } }, // Other Income
                { s:{ r:0,c:35 }, e:{ r:3,c:35 } }, // Total Income
                { s:{ r:0,c:36 }, e:{ r:3,c:36 } }, // Reset Counter
                { s:{ r:0,c:37 }, e:{ r:3,c:37 } }, // Z-Counter

                // ───────────── Row 1 merges ─────────────
                { s:{ r:1,c:11 }, e:{ r:1,c:17 } }, // Deductions → Discount
                { s:{ r:1,c:18 }, e:{ r:3,c:18 } }, // Deductions → Return
                { s:{ r:1,c:19 }, e:{ r:3,c:19 } }, // Deductions → Refund
                { s:{ r:1,c:20 }, e:{ r:3,c:20 } }, // Deductions → Void
                { s:{ r:1,c:21 }, e:{ r:3,c:21 } }, // Deductions → Total Deductions
                { s:{ r:1,c:22 }, e:{ r:1,c:25 } }, // Adjustments → Discount
                { s:{ r:1,c:26 }, e:{ r:3,c:26 } }, // Adjustments → Return
                { s:{ r:1,c:27 }, e:{ r:3,c:27 } }, // Adjustments → Void
                { s:{ r:1,c:28 }, e:{ r:3,c:28 } }, // Adjustments → Manual
                { s:{ r:1,c:29 }, e:{ r:3,c:29 } }, // Adjustments → Total Adjustments
                { s:{ r:1,c:32 }, e:{ r:3,c:32 } }, // Other Income → Excess GC
                { s:{ r:1,c:33 }, e:{ r:3,c:33 } }, // Other Income → Excess RS
                { s:{ r:1,c:34 }, e:{ r:3,c:34 } }, // Other Income → Total

                // ───────────── Row 2 merges ─────────────
                { s:{ r:2,c:11 }, e:{ r:2,c:12 } }, // Deductions → SC
                { s:{ r:2,c:13 }, e:{ r:2,c:14 } }, // Deductions → PWD
                { s:{ r:2,c:15 }, e:{ r:3,c:15 } }, // Deductions → NAAC
                { s:{ r:2,c:16 }, e:{ r:3,c:16 } }, // Deductions → Solo Parent
                { s:{ r:2,c:17 }, e:{ r:3,c:17 } }, // Deductions → MOV
                //{ s:{ r:2,c:18 }, e:{ r:3,c:18 } }, // Deductions → Others

                { s:{ r:2,c:22 }, e:{ r:3,c:22 } }, // Adjustments → Regular
                { s:{ r:2,c:23 }, e:{ r:3,c:23 } }, // Adjustments → Special (5%)
                { s:{ r:2,c:24 }, e:{ r:3,c:24 } }, // Adjustments → Special (20%)
                { s:{ r:2,c:25 }, e:{ r:3,c:25 } }, // Adjustments → Others

                // ───────────── Row 3 merges ─────────────
                { s:{ r:3,c:11 }, e:{ r:3,c:11 } }, // Deductions → SC 5%
                { s:{ r:3,c:12 }, e:{ r:3,c:12 } }, // Deductions → SC 20%
                { s:{ r:3,c:13 }, e:{ r:3,c:13 } }, // Deductions → PWD 5%
                { s:{ r:3,c:14 }, e:{ r:3,c:14 } }  // Deductions → PWD 20%
                ];


                // --------------------------
                // 3. Prepare DATA rows
                // --------------------------
                const rows = data.map(r => [
                    r.businessDate,
                    r.beginningSi,
                    r.endingSi,
                    r.endingBalance,
                    r.beginningBalance,
                    r.salesIssuedManual,
                    r.grossSales,
                    r.grossVatableSales,
                    r.grossVatAmount,
                    r.grossVatExemptSales,
                    r.grossZeroRatedSales,
                    r.SCDiscount5, 
                    r.SCDiscount20,
                    r.PWDDiscount5, 
                    r.PWDDiscount20,
                    r.naacSPDiscount,
                    r.specialTenPercentDiscount,
                    r.movSPDiscount,
                    // r.regularDiscount,
                    r.totalReturns,
                    r.totalRefund,
                    r.totalVoids,
                    r.totalDeductions,
                    r.SCDiscount, 
                    r.PWDDiscount,
                    r.adjSpecialTenPercentDiscount,
                    r.adjustmentOnVatRegular,
                    r.adjustmentOnVatReturns,
                    r.adjustmentOnVatVoids,
                    r.adjustmentOnVatManual,
                    r.totalVatAdjustments,
                    r.vatPayables,
                    r.netAmountReceived,
                    r.excessGC,
                    r.excessRS,
                    r.otherIncomeTotal,
                    r.totalIncome,
                    r.siResetCount,
                    r.zReadingCounter
                ]);

                // ===== CONFIG =====
                const TOTAL_COLS = 38;              // columns 0..37    
                const HALF = Math.floor(TOTAL_COLS / 2);  // 19
                // build titleRows as before but we'll pad them below
                let titleRows = [
                    ["BIR SALES REPORT"],
                    [base.site_company || ""],
                    [(base.site_tin + "-" + base.site_tin_branch_code) || ""],
                    [base.site_address || ""],
                    [], // spacer
                    ["Software: Barter POS Version 5.1", "", "", "", "", "", "", "", "", "Branch Code: " + (base.site_refcode || "")],
                    ["Serial Number: " + (base.serial_number || ""), "", "", "", "", "", "", "", "", "Branch Name: " + (base.site_name || "")],
                    ["Machine Number: " + (base.machine_number || ""), "", "", "", "", "", "", "", "", "PTUSM Number: " + (base.permit_number || "")],
                    ["POS Terminal Number: " + (base.pos_terminal_number || ""), "", "", "", "", "", "", "", "", "Accreditation Number: " + (base.acrreditation_number || "")]
                ];

                // Date row
                let dateLabel = (this.searchDateFrom == this.searchDateTo)
                ? "Date: " + moment(this.searchDateFrom).format(this.dateFormat)
                : "Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat) + " to " + moment(this.searchDateTo).format(this.dateFormat);

                titleRows.push([ dateLabel, "", "", "", "", "", "", "", "", "Cashier ID: " + (base.user_name || "") ]);

                const RIGHT_START = HALF;                 // 19

                function padRowLeftRight(leftValue, rightValue) {
                    const r = Array(TOTAL_COLS).fill("");
                    r[0] = leftValue || "";
                    if (rightValue) r[RIGHT_START] = rightValue;   // Put right-side text at col 19
                    return r;
                }

                // Replace the 5..9 title rows with properly padded rows (ensures right-side visible)
                titleRows[5] = padRowLeftRight("Software: Barter POS Version 5.0", "Branch Code: " + (base.site_refcode || ""));
                titleRows[6] = padRowLeftRight("Serial Number: " + (base.serial_number || ""), "Branch Name: " + (base.site_name || ""));
                titleRows[7] = padRowLeftRight("Machine Number: " + (base.machine_number || ""), "PTUSM Number: " + (base.permit_number || ""));
                titleRows[8] = padRowLeftRight("POS Terminal Number: " + (base.pos_terminal_number || ""), "Accreditation Number: " + (base.acrreditation_number || ""));
                titleRows[9] = padRowLeftRight(dateLabel, "Cashier ID: " + (base.user_name || ""));

                // ===== pad the earlier title lines (0..4) to TOTAL_COLS too =====
                for (let i = 0; i <= 4; i++) {
                    const r = Array(TOTAL_COLS).fill("");
                    // put the existing single-cell text into col 0
                    if (titleRows[i] && titleRows[i][0] !== undefined) r[0] = titleRows[i][0];
                    titleRows[i] = r;
                }

                // ===== pad header & data rows to TOTAL_COLS =====
                const paddedHeader = header.map(row => {
                    const r = row.slice();
                    while (r.length < TOTAL_COLS) r.push("");
                    if (r.length > TOTAL_COLS) r.length = TOTAL_COLS;
                    return r;
                });
                const paddedDataRows = rows.map(row => {
                    const r = row.slice();
                    while (r.length < TOTAL_COLS) r.push("");
                    if (r.length > TOTAL_COLS) r.length = TOTAL_COLS;
                    return r;
                });

                // console.log("HEADER ROW LENGTHS:");
                // header.forEach((r,i)=>console.log("Row", i, r.length));

                // console.log("DATA ROW LENGTHS:");
                // rows.forEach((r,i)=>console.log("Row", i, r.length));

                // console.log("MAX HEADER COLUMNS:", Math.max(...header.map(r => r.length)));
                // console.log("MAX DATA COLUMNS:", Math.max(...rows.map(r => r.length)));

                // console.log("TOTAL MERGES:", merges.length);
                // console.log("HIGHEST MERGE ROW/COL:");
                // console.log(
                // Math.max(...merges.map(m => m.e.r)),
                // Math.max(...merges.map(m => m.e.c))
                // );

                // merges.forEach((m, index) => {
                //     if (m.s.r > m.e.r || m.s.c > m.e.c) {
                //         console.log("INVALID MERGE ORDER at index:", index, m);
                //     }
                //     if (m.e.r > header.length - 1) {
                //         console.log("MERGE OUT OF RANGE ROW at index:", index, m);
                //     }
                //     if (m.e.c > 37) {
                //         console.log("MERGE OUT OF RANGE COL at index:", index, m);
                //     }
                // });

                // header.forEach((row, r) => {
                //     row.forEach((cell, c) => {
                //         if (cell === undefined || cell === null) {
                //         console.log(`UNDEFINED CELL at row ${r} col ${c}`);
                //         }
                //     });
                // });

                // --------------------------
                // 4. Combine header + data
                // --------------------------
                // const sheetData = [...titleRows, ...header, ...rows];
                const sheetData = [...titleRows, ...paddedHeader, ...paddedDataRows];

                // ===== build and set merges =====
                // titleMerges should use TOTAL_COLS - 1 for last column (you already have them); keep as is but compute programmatically to be safe:
                const titleMerges = [
                    // Full-width title rows (unchanged)
                    { s:{r:0,c:0}, e:{r:0,c:TOTAL_COLS-1} },
                    { s:{r:1,c:0}, e:{r:1,c:TOTAL_COLS-1} },
                    { s:{r:2,c:0}, e:{r:2,c:TOTAL_COLS-1} },
                    { s:{r:3,c:0}, e:{r:3,c:TOTAL_COLS-1} },

                    // Row 4 blank — none

                    // Rows 5–9: HALF/HALF split
                    { s:{r:5,c:0},     e:{r:5,c:HALF-1} },    // left half
                    { s:{r:5,c:HALF},  e:{r:5,c:TOTAL_COLS-1} }, // right half

                    { s:{r:6,c:0},     e:{r:6,c:HALF-1} },
                    { s:{r:6,c:HALF},  e:{r:6,c:TOTAL_COLS-1} },

                    { s:{r:7,c:0},     e:{r:7,c:HALF-1} },
                    { s:{r:7,c:HALF},  e:{r:7,c:TOTAL_COLS-1} },

                    { s:{r:8,c:0},     e:{r:8,c:HALF-1} },
                    { s:{r:8,c:HALF},  e:{r:8,c:TOTAL_COLS-1} },

                    { s:{r:9,c:0},     e:{r:9,c:HALF-1} },
                    { s:{r:9,c:HALF},  e:{r:9,c:TOTAL_COLS-1} },
                ];

            // ===== SHIFT your existing header merges down by titleRows.length =====
            const ROW_OFFSET = titleRows.length; // 10
            const shiftedHeaderMerges = merges.map(m => ({
                s: { r: m.s.r + ROW_OFFSET, c: m.s.c },
                e: { r: m.e.r + ROW_OFFSET, c: m.e.c }
            }));

            const finalMerges = [...titleMerges, ...shiftedHeaderMerges];

                // --------------------------
                // 5. Build sheet
                // --------------------------
                const ws = XLSX.utils.aoa_to_sheet(sheetData);
                // ws['!merges'] = merges;
                // ws['!merges'] = [...titleMerges, ...merges];
                ws['!merges'] = finalMerges;

                // Auto column width (adjusted to match header length)
                // ws['!cols'] = Array(sheetData[0].length).fill({ wch: 18 });
                ws['!cols'] = Array(TOTAL_COLS).fill({ wch: 18 });

                
                // --------------------------
                // 6. Export file
                // --------------------------
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "BIR Sales Report");
                XLSX.writeFile(wb, "bir_sales_report.xlsx");

            },

            async generateReport(){
                this.spinning= true;
               
                if(this.searchDateFrom == null || this.searchDateTo == null || this.selectedTerminalId == ''){
                    this.$notification['error']({
                        message: 'Export Error',
                        description: 'Please make sure to check your current filters.'
                    });
                    this.spinning= false;
                    return
                }

                var queryResult = await HTTPRequest.getRequest(this.endPoint + 'z_readings/bir_sales_report?from=' + this.searchDateFrom +  "&to=" + this.searchDateTo + "&terminal_id=" + this.selectedTerminalId , null)

                if (queryResult.report_details[0].report_details.length == 0) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
                var siteSpecific = queryResult.report_details

                var headers = [
                    [
                        {content: 'Business Date', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Beginning SI No.', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Ending SI No.', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Grand Accum. Sales Ending', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Grand Accum. Beg. Balance', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Sales Issued w/ Manual SI/OR (per RR 16-2018)', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Gross Sales for the Day', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Vatable Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'VAT Amount', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Vat-Exempt Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Zero Rated Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},

                        {content: 'Deductions', colSpan: 12, styles:{halign:'center'}},
                        {content: 'Adjustments on VAT', colSpan: 8, styles:{halign:'center'}},
                        {content: 'VAT Payables', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Net Sales', rowSpan: 4, styles:{halign:'center', valign:'center'}},

                        {content: 'Other Income', colSpan: 3, styles:{halign:'center'}},
                        {content: 'Total Income', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Reset Counter', rowSpan: 4, styles:{halign:'center', valign:'center'}},
                        {content: 'Z-Counter', rowSpan: 4, styles:{halign:'center', valign:'center'}}
                    ],
                    [
                        {content:'Discount', colSpan:8, styles:{halign:'center'}},
                        {content:'Return', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Refund', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Void', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Total Deductions', rowSpan:3, styles:{halign:'center', valign:'center'}},

                        {content:'Discount', colSpan:4, styles:{halign:'center'}},
                        {content:'Return', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Void', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Manual', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Total Adjustments', rowSpan:3, styles:{halign:'center', valign:'center'}},

                        {content:'Excess GC', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Excess RS', rowSpan:3, styles:{halign:'center', valign:'center'}},
                        {content:'Total', rowSpan:3, styles:{halign:'center', valign:'center'}}
                    ],
                    [
                        {content:'SC', colSpan:2, styles:{halign:'center'}},
                        {content:'PWD', colSpan:2, styles:{halign:'center'}},
                        {content:'NAAC', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Solo Parent', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'MOV', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Others', rowSpan:2, styles:{halign:'center', valign:'center'}},

                        {content:'Regular', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Special (5%)', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Special (20%)', rowSpan:2, styles:{halign:'center', valign:'center'}},
                        {content:'Others', rowSpan:2, styles:{halign:'center', valign:'center'}}
                    ],
                    [
                        {content:'5%', styles:{halign:'center'}},
                        {content:'20%', styles:{halign:'center'}},
                        {content:'5%', styles:{halign:'center'}},
                        {content:'20%', styles:{halign:'center'}}
                    ]
                ];


                var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: [615, 1670] });

                let reportLogo = document.getElementById('reportLogo');
                doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                var siteTotalSales = 0, siteTotalVatablesSales = 0, siteTotalVatAmount = 0, siteTotalVatExemptSales = 0,
                    siteTotalZeroRatedSales = 0, siteTotalRegularDeductions = 0, siteTotalSpecialDeductions = 0, siteTotalReturnDeductions = 0,
                    siteTotalVoidDeductions = 0, siteTotalManualDeductions = 0, siteTotalDeductions2 = 0, siteTotalVatAdjustmentRegular = 0,
                    siteTotalVatAdjustmentSpecial = 0, siteTotalVatAdjustmentReturn = 0, siteTotalVatAdjustmentVoid = 0, siteTotalVatAdjustmentManual = 0,
                    siteTotalAdjustment2 = 0, siteTotalVatPayables = 0, siteTotalNetAmountReceived = 0, siteTotalExcessGC = 0, siteTotalExcessRS = 0,siteTotalSalesIncludingExcess = 0, siteTotalVatAdjustmentSpecial2 = 0, siteTotalSpecialDeductions2 = 0;

                for(var x=0; x < siteSpecific.length; x++){
                    this.birCombinedReports = siteSpecific[x].report_details

                    console.log("Site specific")
                    console.log(siteSpecific[x])

                    if(x > 0 ){
                        doc.addPage();
                    }

                    var reportData = [];

                    let allTotal = {};

                    for(var i=0; i < this.birCombinedReports.length; i++){
                        var reportLine = this.birCombinedReports[i]
                        var reportLineDetails = JSON.parse(reportLine.reading_details)

                        this.totalAllAmount(allTotal, reportLineDetails);

                        const formattedDetails = this.formattingExportData(reportLine.business_date, reportLineDetails);
                        const { grossSales, deductions, adjustments, otherIncome } = formattedDetails;
                        const detail = [
                            // Main (1–11)
                            formattedDetails.businessDate,
                            formattedDetails.beginningSi,
                            formattedDetails.endingSi,
                            formattedDetails.endingBalance,
                            formattedDetails.beginningBalance,
                            formattedDetails.manualIssuedSales,
                            grossSales.total,
                            grossSales.vatable,
                            grossSales.vatAmount,
                            grossSales.vatExempt,
                            grossSales.zeroRated,

                            // Deductions → Discount (12–19)
                            deductions.SCDiscount5,
                            deductions.SCDiscount20,
                            deductions.PWDDiscount5,
                            deductions.PWDDiscount20,
                            deductions.naacSPDiscount,
                            deductions.specialTenPercentDiscount,
                            deductions.movSPDiscount,
                            deductions.regular,          // << you previously put regular, incorrect

                            // Deductions → Others (20–23)
                            deductions.returns,
                            deductions.refund,
                            deductions.void,
                            deductions.total,

                            // Adjustments on VAT → Discount (24–27)
                            adjustments.SCDiscount,
                            adjustments.PWDDiscount,
                            adjustments.specialTenPercentDiscount,
                            adjustments.regular,         // < previously wrong

                            // Adjustments on VAT → Others (28–31)
                            adjustments.return,
                            adjustments.void,
                            adjustments.manual,
                            adjustments.total,

                            // 32–33
                            formattedDetails.vatPayables,
                            formattedDetails.netAmountReceived,

                            // Other Income (34–36)
                            otherIncome.excessGC,
                            otherIncome.excessRS,
                            otherIncome.total,

                            //Total Income
                            formattedDetails.totalIncome,

                            // 37–38
                            formattedDetails.siResetCount,
                            formattedDetails.zReadingCounter
                        ];



                        reportData.push(Object.assign({}, detail))
                    }

                    
                    // for (const key in allTotal) { allTotal[key] = formatNumber((parseFloat(allTotal[key]) || 0.00).toFixed(4)); }

                    // Convert formatted string → number
                    const toNum = (v) =>
                        parseFloat(String(v == null || v === "" ? "0" : v).replace(/,/g, ""));

                    // Convert number → formatted string (no commas in decimal part)
                    const toStr = (v) => {
                        const num = Number(v || 0);
                        const fixed = num.toFixed(4);
                        const [i, d] = fixed.split(".");
                        return `${Number(i).toLocaleString()}.${d}`;
                    };

                    // Final totals cleanup (safe)
                    for (const key in allTotal) {
                        const numericValue = toNum(allTotal[key]);
                        allTotal[key] = toStr(numericValue);
                    }


                    console.log("allTotal")
                    console.log(allTotal)

                    if(x == (siteSpecific.length - 1)){
                      // Input total values
                      reportData.push([
                        "TOTAL:",
                        '', '', '', '', '', // Main
                        allTotal.totalSales,
                        allTotal.totalVatablesSales,
                        allTotal.totalVatAmount,
                        allTotal.totalVatExemptSales,
                        allTotal.totalZeroRatedSales,
                        allTotal.totalSCDiscount5,
                        allTotal.totalSCDiscount20,
                        allTotal.totalPWDDiscount5,
                        allTotal.totalPWDDiscount20,
                        allTotal.totalNaacSPDiscount,
                        allTotal.totalSpecialTenPercent,
                        allTotal.totalMovSPDiscount,
                        allTotal.totalRegularDeductions,
                        allTotal.totalReturnDeductions,
                        allTotal.totalRefundDeductions,
                        allTotal.totalVoidDeductions,
                        allTotal.totalDeductions2,

                       
                        allTotal.totalVatAdjustmentSC,  //For checking
                        allTotal.totalVatAdjustmentPWD, //For checking
                        allTotal.totalVatAdjustmentSpecialTen,
                        allTotal.totalVatAdjustmentRegular,

                        allTotal.totalVatAdjustmentReturn,
                        allTotal.totalVatAdjustmentVoid,
                        allTotal.totalVatAdjustmentManual,
                        allTotal.totalAdjustment2,
                        
                        allTotal.totalVatPayables,
                        allTotal.totalNetAmountReceived,

                        allTotal.totalExcessGC,
                        allTotal.totalExcessRS,
                        allTotal.totalOtherIncome,
                        allTotal.totalIncome,

                        '', '' // Reset & Z Counter (or you can sum if needed)
                    ]);

                    }


                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    doc.text(15,20,"BIR Sales Report")
                    doc.setFontSize(12);
                    doc.text(15,25, siteSpecific[x].site_company || '')
                    doc.text(15,30, siteSpecific[x].site_tin + '-' + siteSpecific[x].site_tin_branch_code || '')
                    doc.text(15,35, siteSpecific[x].site_address || '')



                    doc.setFontType("normal");
                    doc.setFontSize(10);
                    // doc.text(15,30,"Company: " + siteSpecific[x].site_company)
                    // doc.text(15,35,"TIN: " + siteSpecific[x].site_tin)
                    // doc.text(15,45,"Address: " + siteSpecific[x].site_address)
                    doc.text(15,45,"Software: Barter POS Version 5.0")
                    doc.text(15,50,"Serial Number: " + siteSpecific[x].serial_number)
                    doc.text(15,55,"Machine Number: " + siteSpecific[x].machine_number)
                    doc.text(15,60,"POS Terminal Number: " + siteSpecific[x].pos_terminal_number)
                    
                    // doc.text(15,70,"Permit Number:  " + siteSpecific[x].permit_number)

                    if( this.searchDateFrom == this.searchDateTo){
                            doc.text(15,65,"Date: " +  moment(this.searchDateFrom).format(this.dateFormat) )
                    } else {
                        doc.text(15,65,"Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat)  + " to " + moment(this.searchDateTo).format(this.dateFormat))
                    }

                    doc.text(140,45,"Branch Code: " + siteSpecific[x].site_refcode)
                    doc.text(140,50,"Branch Name: " + siteSpecific[x].site_name)

                    doc.text(140,55,"PTUSM Number: " + siteSpecific[x].permit_number)
                    doc.text(140,60,"Accreditation Number: " + siteSpecific[x].acrreditation_number)
                    doc.text(140,65,"Cashier ID: " + siteSpecific[x].user_name)
 

                    doc.autoTable(
                        {
                            startY: 80,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            styles: {
                                cellPadding: 0.5, fontSize: 7,
                                lineWidth: 0.05,
                                halign: 'right',
                                overflow: 'linebreak'
                            },
                            headStyles: {
                                lineWidth: 0.05,
                                cellPadding: 2,
                                overflow: 'linebreak',
                            },
                            columnStyles: {
                                0: {halign: "center"},
                                1: {halign: "center", cellWidth: 20},
                                2: {halign: "center", cellWidth: 20},
                                3: {halign: "center", cellWidth: 20},
                                4: {halign: "center", cellWidth: 20},
                                5: {halign: "center", cellWidth: 20},
                                6: {halign: "center", cellWidth: 20},
                                28: {halign: "center"},
                                29: {halign: "center"},
                            }
                        }
                    );

                    doc.setFontSize(8);
                    doc.text(15,230,"Printed By: " + secureStorage.getItem("email"))
                    doc.text(550,230,"BIR Sales Report", "right")
                    doc.text(15,235,"Print Date: " + moment().format(this.dateFormat2))
                    doc.text(550,235,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                }
                // doc.output('dataurlnewwindow');
                window.open(URL.createObjectURL(doc.output("blob")))
                this.spinning= false;
            },
        }
    };
</script>

<style></style>
